import { render } from "./ChatBox.vue?vue&type=template&id=da4e4fd4"
import script from "./ChatBox.vue?vue&type=script&lang=js"
export * from "./ChatBox.vue?vue&type=script&lang=js"
script.render = render

export default script